import React, { useState, useContext, useEffect } from "react";
import { decode } from "js-base64";
import { useParams } from "react-router";
import { NotificationContext } from "./Notification";
import LoaderPR from "./LoaderPR";
import { redirectPage } from "./Utils";
import { getDomain, getPSI, handleSessionValidation } from "./Theme";
import PasswordInput from "./PasswordInput";
import SSOService, { serviceUrl } from "./SSOService";
import { Form, HeaderForm, ContentForm, DescriptionForm, FooterForm } from "./Form";

function SetNewPassword() {
  const domain = getDomain();
  const { email } = useParams();
  const id = getPSI();
  const [password, setPassword] = useState("");
  const [showLoading, setLoading] = useState(false);
  const { addToast } = useContext(NotificationContext);
  const emailDecoded = decode(email);
  const service = new SSOService();

  useEffect(() => {
    setLoading(true);
    handleSessionValidation(addToast).then(() => {
      setLoading(false);
    });
  }, []);

  return (
    <Form name="loginForm" autoComplete="on">
      <HeaderForm />
      <ContentForm>
        <DescriptionForm
         title="Set New Password"
        />

        <PasswordInput
          onChange={(passwordInput) => {
            setPassword(passwordInput);
          }}
          name="password"
          label="New Password"
          validate={true}
          missmatch={false}
          autoComplete={true}
        />
        <LoaderPR showLoading={showLoading} />
      </ContentForm>
      <FooterForm>
        <button
          className="zds-button-primary zds-button-large"
          type="submit"
          onClick={(event) => {
            event.preventDefault();
            if (password.trim() === "") {
              addToast("New Password is required", "error");
              return;
            }
            setLoading(true);
            handleSessionValidation(addToast).then(() => {
              service
                .setNewPassword(emailDecoded, password, id, domain)
                .then((data) => {
                  redirectPage(data.url);
                })
                .catch((err) => {
                  if (err.refreshSession === true) {
                    addToast("Your session expired.", "error");
                    redirectPage(
                      `${serviceUrl}/checklogin?returnUrl=${err.returnUrl}`
                    );
                    return;
                  }else if(err.returnToLogin === true){
                    addToast("Your session expired.", "error");
                    redirectPage(
                      `/login?domain=${domain}`
                    );
                  }
                  setLoading(false);
                  addToast(err.error, "error");
                });
            });
          }}
        >
          Set New Password
        </button>
      </FooterForm>
    </Form>
  );
}

export default SetNewPassword;
